// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class VolatilityLabChartData {
    constructor(priceStep, pricePrecision, underlierPrice, seriesMapDataSeries, xScaleLegend) {
        this.priceStep = 0;
        this.pricePrecision = 0;
        this.xScaleLegend = new Map();
        this.underlierPrice = NaN;
        this.seriesMapDataSeries = new Map();
        this.priceStep = priceStep;
        this.pricePrecision = pricePrecision;
        this.xScaleLegend = xScaleLegend;
        this.underlierPrice = underlierPrice;
        this.seriesMapDataSeries = seriesMapDataSeries;
    }
}
